import React from "react";
import ExperienceActionItem from "./ExperienceActionItem";

export default function ExperienceActionList(
    {
        items,
        numberOfItems,
        parentOrder
    } ) {

    return (
        <div>
            { items
                ?.sort( ( a, b ) => a.order - b.order )
                .map( action => (
                    <ExperienceActionItem
                        key={ action.order }
                        item={ action }
                        parentOrder={ parentOrder }
                        numberOfItems={ numberOfItems }
                    />
                ) ) }
        </div>
    );
}
